import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { FieldPath } from 'react-hook-form';

// TODO: Descomentar cuando el backend implemente la funcionalidad de tamaño de paquete
// import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';

import { Countries } from '@/utils/common';

import { SchemaType } from '../schema';

export const getPackageWeight = (country: Countries) => {
  const countryWeights = {
    MEX,
    COL,
    CHL,
    PER,
  };
  return countryWeights[country];
};

const CHL = [
  {
    value: '1',
    label: 'Menos de 3 kg',
  },
  {
    value: '2',
    label: 'De 3 a 6 kg',
  },
  {
    value: '3',
    label: 'De 6 a 10 kg',
  },
  {
    value: '4',
    label: 'De 10 a 15kg',
  },
  {
    value: '5',
    label: 'Mayor de 15kg',
  },
];

const MEX = [
  {
    value: '1',
    label: 'Menos de 1 kg',
  },
  {
    value: '2',
    label: 'De 1 a 2 kg',
  },
  {
    value: '3',
    label: 'De 2 a 3 kg',
  },
  {
    value: '4',
    label: 'De 3 a 5kg',
  },
  {
    value: '5',
    label: 'De 5 a 20kg',
  },
];

const COL = [
  {
    value: '1',
    label: 'Menos de 1 kg *',
  },
  {
    value: '2',
    label: 'De 1 a 3 kg *',
  },
  {
    value: '3',
    label: 'De 3 a 5 kg *',
  },
  {
    value: '4',
    label: 'De 5 a 15kg',
  },
  {
    value: '5',
    label: 'De 15 a 32kg',
  },
];

const PER = [
  {
    value: '1',
    label: 'Menos de 2 kg',
  },
  {
    value: '2',
    label: 'De 2 a 5 kg',
  },
  {
    value: '3',
    label: 'De 5 a 15 kg',
  },
  {
    value: '4',
    label: 'De 15 a 20kg',
  },
];

type FormField = {
  name: FieldPath<SchemaType>;
  label: string;
  placeholder?: string;
  icon?: React.ReactNode;
  type: 'input' | 'phone' | 'checkbox' | 'select' | 'direction';
  fullWidth?: boolean;
  options?: { value: string; label: string }[];
};

export const formPerCountryFunc = (country: Countries): FormField[] => {
  const formPerCountry: Record<Countries, FormField[]> = {
    MEX: [
      {
        name: 'company.name',
        label: 'Nombre comercial',
        placeholder: '99minutos',
        icon: <StorefrontOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.legalName',
        label: 'Nombre Legal',
        placeholder: '99minutos S.A de C.V.',
        icon: <StorefrontOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.phone',
        label: 'Teléfono',
        placeholder: '+525555555555',
        icon: <PhoneIphoneOutlinedIcon />,
        type: 'phone',
        fullWidth: true,
      },
      {
        name: 'company.companyType',
        label: 'Régimen fiscal',
        icon: <PersonOutlineOutlinedIcon />,
        options: [
          { value: 'naturalPerson', label: 'Persona física' },
          { value: 'corporateEntity', label: 'Persona moral' },
        ],
        type: 'checkbox',
      },
      {
        name: 'company.rfc',
        label: 'RFC',
        icon: <ArticleOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.address',
        label: 'Dirección de facturación',
        icon: <FmdGoodOutlinedIcon />,
        placeholder: 'Dirección',
        type: 'direction',
      },
      {
        name: 'company.zipCode',
        label: 'Código Postal',
        icon: <MyLocationOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.email',
        label: 'Email de facturación',
        icon: <EmailOutlinedIcon />,
        type: 'input',
      },
      // TODO: Descomentar cuando el backend implemente la funcionalidad de tamaño de paquete
      // {
      //   name: 'company.packageSize',
      //   label: 'Tamaño de paquete',
      //   icon: <StraightenOutlinedIcon />,
      //   options: getPackageWeight(country),
      //   type: 'select',
      //   placeholder: 'Selecciona un tamaño',
      // },
      {
        name: 'company.taxRegime',
        label: 'Régimen',
        icon: <ContactPageOutlinedIcon />,
        options: [],
        type: 'select',
      },
      {
        name: 'company.cfdiUse',
        label: 'Uso de CFDI',
        icon: <FindInPageOutlinedIcon />,
        options: [],
        type: 'select',
        placeholder: 'Selecciona un uso',
      },
    ],
    PER: [
      {
        name: 'company.name',
        label: 'Nombre',
        placeholder: '99minutos',
        icon: <StorefrontOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.companyName',
        label: 'Razón Social',
        placeholder: '99minutos S.A de C.V.',
        icon: <PhoneIphoneOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.companyType',
        label: 'Régimen fiscal',
        icon: <PersonOutlineOutlinedIcon />,
        options: [
          { value: 'naturalPerson', label: 'Persona neutral' },
          { value: 'corporateEntity', label: 'Persona jurídica' },
        ],
        type: 'checkbox',
      },
      {
        name: 'company.identification',
        label: 'DNI/RUC',
        placeholder: 'BEMA941120PH1',
        icon: <ArticleOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.address',
        label: 'Dirección de facturación',
        icon: <FmdGoodOutlinedIcon />,
        placeholder: 'Dirección',
        type: 'direction',
      },
      {
        name: 'company.email',
        label: 'Email de facturación',
        icon: <EmailOutlinedIcon />,
        type: 'input',
        fullWidth: true,
      },
      // TODO: Descomentar cuando el backend implemente la funcionalidad de tamaño de paquete
      // {
      //   name: 'company.packageSize',
      //   label: 'Tamaño de paquete',
      //   icon: <StraightenOutlinedIcon />,
      //   options: getPackageWeight(country),
      //   type: 'select',
      //   placeholder: 'Selecciona un tamaño',
      // },
    ],
    COL: [
      {
        name: 'company.name',
        label: 'Nombre',
        placeholder: '99minutos',
        icon: <StorefrontOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.companyName',
        label: 'Razón Social',
        placeholder: '99minutos S.A de C.V.',
        icon: <PhoneIphoneOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.companyType',
        label: 'Régimen fiscal',
        icon: <PersonOutlineOutlinedIcon />,
        options: [
          { value: 'naturalPerson', label: 'Persona neutral' },
          { value: 'corporateEntity', label: 'Persona jurídica' },
        ],
        type: 'checkbox',
      },
      {
        name: 'company.identification',
        label: 'Identificación/Cédula',
        placeholder: 'BEMA941120PH1',
        icon: <ArticleOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.address',
        label: 'Dirección de facturación',
        icon: <FmdGoodOutlinedIcon />,
        placeholder: 'Dirección',
        type: 'direction',
      },
      {
        name: 'company.email',
        label: 'Email de facturación',
        icon: <EmailOutlinedIcon />,
        type: 'input',
        fullWidth: true,
      },
      // TODO: Descomentar cuando el backend implemente la funcionalidad de tamaño de paquete
      // {
      //   name: 'company.packageSize',
      //   label: 'Tamaño de paquete',
      //   icon: <StraightenOutlinedIcon />,
      //   options: getPackageWeight(country),
      //   type: 'select',
      //   placeholder: 'Selecciona un tamaño',
      // },
    ],
    CHL: [
      {
        name: 'company.name',
        label: 'Nombre',
        placeholder: '99minutos',
        icon: <StorefrontOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.companyName',
        label: 'Razón Social',
        placeholder: '99minutos S.A de C.V.',
        icon: <PhoneIphoneOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.companyType',
        label: 'Régimen fiscal',
        icon: <PersonOutlineOutlinedIcon />,
        options: [
          { value: 'naturalPerson', label: 'Persona neutral' },
          { value: 'corporateEntity', label: 'Persona jurídica' },
        ],
        type: 'checkbox',
      },
      {
        name: 'company.identification',
        label: 'Identificación/Cédula',
        placeholder: 'BEMA941120PH1',
        icon: <ArticleOutlinedIcon />,
        type: 'input',
      },
      {
        name: 'company.address',
        label: 'Dirección de facturación',
        icon: <FmdGoodOutlinedIcon />,
        placeholder: 'Dirección',
        type: 'direction',
      },
      {
        name: 'company.email',
        label: 'Email de facturación',
        icon: <EmailOutlinedIcon />,
        type: 'input',
        fullWidth: true,
      },
      // TODO: Descomentar cuando el backend implemente la funcionalidad de tamaño de paquete
      // {
      //   name: 'company.packageSize',
      //   label: 'Tamaño de paquete',
      //   icon: <StraightenOutlinedIcon />,
      //   options: getPackageWeight(country),
      //   type: 'select',
      //   placeholder: 'Selecciona un tamaño',
      // },
    ],
  };

  return formPerCountry[country];
};
